<div class="exam-register-container">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-state">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">กำลังโหลด...</span>
    </div>
    <p class="mt-3">กำลังโหลดข้อมูลการสอบ...</p>
  </div>

  <!-- Exam Content -->
  <div *ngIf="!isLoading && examData" class="exam-content">

    <!-- Header Section -->
    <div class="exam-header">
      <button class="btn-back" (click)="goBack()">
        <i class="bi bi-arrow-left"></i>
        <span>กลับ</span>
      </button>

      <div class="header-content">
        <div class="exam-badge-group">
          <span class="level-badge" [ngClass]="getValuerRankBadgeClass(examData.valuerRank)">
            {{ examData.valuerRank }}
          </span>
          <span class="category-badge">{{ examData.examStatus }}</span>
        </div>

        <h1 class="exam-title">{{ examData.examTopic }}</h1>
      </div>
    </div>

    <!-- Tabs Navigation -->
    <div class="tabs-navigation">
      <button class="tab-button" [class.active]="isActiveTab('overview')" (click)="setActiveTab('overview')">
        รายละเอียด
      </button>
      <button class="tab-button" [class.active]="isActiveTab('payment')" (click)="setActiveTab('payment')">
        วิธีการชำระเงิน
      </button>
    </div>

    <!-- Tab Content -->
    <div class="tab-content-area">

      <!-- Overview Tab -->
      <div class="tab-pane" [class.active]="isActiveTab('overview')">

        <!-- Exam Details Grid -->
        <div class="content-section">
          <h3 class="section-title">
            <i class="bi bi-info-circle"></i>
            <span>รายละเอียดการสอบ</span>
          </h3>
          <div class="details-grid">
            <div class="detail-card">
              <div class="detail-icon">
                <i class="bi bi-award"></i>
              </div>
              <div class="detail-content">
                <label>ค่าสอบ</label>
                <p>฿{{ formatPrice(examData.examFee) }}</p>
              </div>
            </div>

            <div class="detail-card">
              <div class="detail-icon">
                <i class="bi bi-calendar-event"></i>
              </div>
              <div class="detail-content">
                <label>วันสอบ</label>
                <p>{{ formatDate(examData.examDate) }}</p>
              </div>
            </div>

            <div class="detail-card">
              <div class="detail-icon">
                <i class="bi bi-clock"></i>
              </div>
              <div class="detail-content">
                <label>เวลาสอบ</label>
                <p>{{ examData.examTime }}</p>
              </div>
            </div>

            <div class="detail-card">
              <div class="detail-icon">
                <i class="bi bi-geo-alt"></i>
              </div>
              <div class="detail-content">
                <label>สถานที่สอบ</label>
                <p>{{ examData.examLocation }}</p>
              </div>
            </div>

            <div class="detail-card" *ngIf="examData.registrationDeadline">
              <div class="detail-icon">
                <i class="bi bi-calendar-x"></i>
              </div>
              <div class="detail-content">
                <label>ปิดรับสมัคร</label>
                <p>{{ formatDate(examData.registrationDeadline) }}</p>
              </div>
            </div>

            <div class="detail-card">
              <div class="detail-icon">
                <i class="bi bi-star"></i>
              </div>
              <div class="detail-content">
                <label>ระดับผู้ประเมิน</label>
                <p>{{ examData.valuerRank }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Remarks -->
        <div class="content-section" *ngIf="examData.remarks">
          <div class="alert-info">
            <i class="bi bi-info-circle"></i>
            <div>
              <strong>หมายเหตุ:</strong>
              <p>{{ examData.remarks }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Payment Tab -->
      <div class="tab-pane" [class.active]="isActiveTab('payment')">
        <div class="content-section">
          <h3 class="section-title">
            <i class="bi bi-credit-card"></i>
            <span>วิธีการชำระเงิน</span>
          </h3>
          <p class="text-muted mb-4">แสดงวิธีและช่องทางการชำระเงินที่รองรับ</p>

          <div class="payment-methods">
            <!-- Credit Card -->
            <!-- <div class="payment-method">
              <div class="payment-header">
                <i class="bi bi-credit-card-2-front"></i>
                <span>วิธีการชำระด้วยบัตรเครดิต/เดบิต</span>
              </div>
              <div class="payment-body">
                <p>รองรับบัตรเครดิต/เดบิตทุกธนาคาร</p>
                <div class="card-brands">
                  <span class="badge badge-primary">VISA</span>
                  <span class="badge badge-info">Mastercard</span>
                  <span class="badge badge-warning">JCB</span>
                </div>
              </div>
            </div> -->

            <!-- Bank Transfer -->
            <div class="payment-method">
              <div class="payment-header">
                <i class="bi bi-bank"></i>
                <span>วิธีการโอนเงินผ่านธนาคาร</span>
              </div>
              <div class="payment-body">
                <p>โอนเงินผ่านธนาคาร</p>
                <div class="bank-details">
                  <p><strong>ธนาคาร:</strong> ธนาคารกรุงเทพ ประเภทออมทรัพย์</p>
                  <p><strong>เลขที่บัญชี:</strong> 137-4-01388-4</p>
                  <p><strong>ชื่อบัญชี:</strong> บัญชีเพื่อการจัดสอบผู้ประเมินหลัก
                    สมาคมผู้ประเมินค่าทรัพย์สินแห่งประเทศไทย</p>
                </div>
              </div>
            </div>

            <!-- QR Code -->
            <!-- <div class="payment-method">
              <div class="payment-header">
                <i class="bi bi-qr-code"></i>
                <span>วิธีการชำระเงินด้วย QR Code</span>
              </div>
              <div class="payment-body">
                <p>สแกน QR Code เพื่อชำระเงิน</p>
                <div class="qr-placeholder">
                  <i class="bi bi-qr-code"></i>
                  <p>QR Code จะแสดงเมื่อทำการสั่งซื้อ</p>
                </div>
              </div>
            </div> -->

            <!-- Online Banking -->
            <!-- <div class="payment-method">
              <div class="payment-header">
                <i class="bi bi-globe"></i>
                <span>วิธีการชำระเงินด้วยการโอนเงิน</span>
              </div>
              <div class="payment-body">
                <p>โอนเงินผ่าน Internet Banking หรือ Mobile Banking</p>
                <p class="info-text">
                  <i class="bi bi-info-circle"></i>
                  คำสั่งซื้อจะเสร็จสมบูรณ์ภายใน 24 ชั่วโมงหลังจากโอนเงิน
                </p>
              </div>
            </div>
            -->
          </div>
        </div>
      </div>

    </div>

    <!-- File Upload Section (Outside tabs, in white zone) -->
    <div class="file-upload-section" *ngIf="examData.examStatusId === 2">
      <div class="upload-header">
        <i class="bi bi-file-earmark-text"></i>
        <h3>หลักฐานการสมัครสอบ</h3>
      </div>
      <p class="upload-description">กรุณาอัพโหลดหลักฐานการสมัครสอบ (JPG, PNG หรือ PDF ขนาดไม่เกิน 5MB)</p>

      <!-- Requirements Info Box -->
      <div class="requirements-box">
        <div class="requirements-header">
          <i class="bi bi-clipboard-check"></i>
          <span>เอกสารที่ต้องการสำหรับการสมัครสอบ</span>
        </div>
        <div class="requirements-note">
          <i class="bi bi-exclamation-circle"></i>
          <span>(กรุณารวมเอกสารทั้งหมดเป็นไฟล์เดียว ในไฟล์ pdf เพื่อให้ได้ผลลัพธ์ที่ดีที่สุด แต่หากไม่สะดวก
            เพื่อความสะดวกท่านสามารถรวมเอกสารทั้งหมดเป็นไฟล์รูปภาพ)</span>
        </div>
        <ul class="requirements-list">
          <li>
            <span class="requirement-number">1.</span>
            <span class="requirement-text">แบบคำขอสมัครสอบเป็นผู้ประเมินหลักของสมาคม</span>
          </li>
          <li>
            <span class="requirement-number">2.</span>
            <span class="requirement-text">สำเนาบัตรประชาชน (รับรองสำเนาถูกต้อง)</span>
          </li>
          <li>
            <span class="requirement-number">3.</span>
            <span class="requirement-text">สำเนาทะเบียนบ้าน</span>
          </li>
          <li>
            <span class="requirement-number">4.</span>
            <span class="requirement-text">สำเนาบัตรสมาชิกสมาคมฯ</span>
          </li>
          <li>
            <span class="requirement-number">5.</span>
            <span class="requirement-text">สำเนาวุฒิบัตรหรือเอกสารแสดงผลการศึกษา</span>
          </li>
          <li>
            <span class="requirement-number">6.</span>
            <span
              class="requirement-text">หนังสือรับรองจากหน่วยงานว่าเป็นบุคคลที่มีความรู้ความสามารถและมีประสบการณ์ในการประเมินมูลค่าทรัพย์สินตามหลักเกณฑ์และเงื่อนไขที่สมาคมกำหนด</span>
          </li>
          <li>
            <span class="requirement-number">7.</span>
            <span class="requirement-text">รูปถ่าย 1 นิ้ว 2 รูป (ถ่ายหน้าตรง ไม่เกิน 6 เดือน ก่อนวันยื่นคำขอ สำหรับ
              ทำบัตร)</span>
          </li>
        </ul>
      </div>

      <!-- File Input Area -->
      <div class="upload-area" *ngIf="!selectedFile">
        <label for="examEvidenceFile" class="upload-label">
          <div class="upload-icon">
            <i class="bi bi-cloud-arrow-up"></i>
          </div>
          <div class="upload-text">
            <span class="main-text">คลิกเพื่อเลือกไฟล์</span>
            <span class="sub-text">รองรับไฟล์ JPG, PNG, PDF (ขนาดไม่เกิน 5MB)</span>
          </div>
        </label>
        <input type="file" id="examEvidenceFile" class="file-input-hidden" accept=".jpg,.jpeg,.png,.pdf"
          (change)="onFileSelected($event)">
      </div>

      <!-- File Selected Display -->
      <div class="file-selected" *ngIf="selectedFile && !fileError">
        <div class="file-card">
          <div class="file-icon-wrapper">
            <i class="bi"
              [ngClass]="selectedFile.type === 'application/pdf' ? 'bi-file-earmark-pdf-fill' : 'bi-file-earmark-image-fill'"></i>
          </div>
          <div class="file-info-wrapper">
            <div class="file-name-display">{{ selectedFile.name }}</div>
            <div class="file-meta">
              <span class="file-size-display">{{ (selectedFile.size / 1024).toFixed(2) }} KB</span>
              <span class="file-type-badge">{{ selectedFile.type === 'application/pdf' ? 'PDF' : 'รูปภาพ' }}</span>
            </div>
          </div>
          <button type="button" class="btn-remove-file" (click)="removeFile()" title="ลบไฟล์">
            <i class="bi bi-trash"></i>
          </button>
        </div>

        <!-- Image Preview Thumbnail -->
        <div class="preview-thumbnail" *ngIf="filePreviewUrl">
          <img [src]="filePreviewUrl" alt="Preview">
        </div>

        <!-- Success Badge -->
        <div class="success-badge">
          <i class="bi bi-check-circle-fill"></i>
          <span>ไฟล์พร้อมสำหรับการอัพโหลด</span>
        </div>
      </div>

      <!-- Error Message -->
      <div class="error-message" *ngIf="fileError">
        <i class="bi bi-exclamation-circle-fill"></i>
        <span>{{ fileError }}</span>
      </div>
    </div>

    <!-- Enrollment Button (Fixed at bottom) -->
    <div class="enrollment-footer" *ngIf="examData.examStatusId === 2">
      <div class="footer-content">
        <div class="price-info">
          <span class="price-label">ค่าลงทะเบียน</span>
          <span class="price-amount">฿{{ formatPrice(examData.examFee) }}</span>
        </div>
        <button class="btn-enroll" (click)="enrollExam()" [disabled]="isEnrollDisabled()"
          [class.disabled]="isEnrollDisabled()">
          <i class="bi bi-check-circle-fill"></i>
          <span>ลงทะเบียนสอบ</span>
        </button>
      </div>
    </div>

  </div>
</div>